module.exports = __webpack_public_path__ + "img/triticale_surge.30c12024.jpg";